/*
BreakpointController
*/
export const CROSS_BREAKPOINT = 'cross_breakpoint';

/*JS_BREAKPOINT_EXPORTS*/
export const XSMALL = 400;
export const SMALL = 600;
export const MEDIUM = 800;
export const LARGE = 1000;
export const NAVIGATION = 1000;
export const ELEVEN = 1100;
export const XLARGE = 1200;
export const YUUUGE = 1400;
/*END_JS_BREAKPOINT_EXPORTS*/

let $ = window.jQuery;

var win,
    currentBreakpoint = null,
    breakpoints =
        /*JS_BREAKPOINT_ARRAY*/
        [ XSMALL, SMALL, MEDIUM, LARGE, NAVIGATION, ELEVEN, XLARGE, YUUUGE ]
/*END_JS_BREAKPOINT_ARRAY*/

function onDocumentReady() {
    win = $(window);
    win.on({
        resize: checkWindow,
        load: checkWindow
    });
    setTimeout(checkWindow, 0);
}

function checkWindow() {
    var w = win.width(),
        ret = 0;

    for (var i = 0; i < breakpoints.length; i++) {
        var breakpoint = breakpoints[i];
        if (w >= breakpoint) {
            ret = breakpoint;
        } else {
            break;
        }
    }

    setBreakpoint(ret);
}

function setBreakpoint(breakpoint) {
    if (breakpoint !== currentBreakpoint) {
        $(document).trigger(CROSS_BREAKPOINT, [breakpoint]);
    }

    currentBreakpoint = breakpoint;
}

export function getBreakpoint() {
    return currentBreakpoint;
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
